import { Box, Loader, Typography } from '@altermaind/web/ui';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';

type Props = {
  title: string;
  description: string;
};

export const LoaderFullPage = ({ title, description }: Props) => {
  const { genericResponsiveValue } = useResponsiveStyle();

  return (
    <Box
      position='fixed'
      top='0'
      left='0'
      width='100%'
      height='100%'
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      background='rgba(0, 0, 0, 0.9)'
      zIndex='9999'
      px={genericResponsiveValue({
        breakPoints: { desktop: 'none' },
        defaultValue: 'xs',
      })}
      textAlign='center'
    >
      <Typography variant='special' mb='xxs'>
        {title}
      </Typography>
      <Typography variant='p2/light' mb='m'>
        {description}
      </Typography>
      <Loader size='xl' />
    </Box>
  );
};
